import type { FC, ReactNode } from "react";

import styles from "./BenefitsList.module.scss";

export type CartOverviewTierBenefit = {
  icon: ReactNode;
  text: string;
};

export type BenefitsListProps = {
  benefits: CartOverviewTierBenefit[];
  title?: string;
};

export const BenefitsList: FC<BenefitsListProps> = ({ benefits, title }) => (
  <section className={styles.benefits} data-testid="cart-overview-tier-benefits">
    {title && <p className={styles.benefitsTitle}>{title}</p>}
    <ul className={styles.benefitsList}>
      {benefits.map(({ icon, text }, index) => (
        <li className={styles.benefit} key={`${text}-${index}`}>
          <span className={styles.benefitIcon} aria-hidden="true">
            {icon}
          </span>
          <span className={styles.benefitText}>{text}</span>
        </li>
      ))}
    </ul>
  </section>
);
